import { Box, Image, Stats, MapOverlay } from '../../components';

import { DockGroups_dockGroups } from '../../core-types';

type Props = {
  mapboxApiAccessToken: string;
  primaryColor: string;
  dockGroups: Array<DockGroups_dockGroups | null>;
};

const mapStyle = 'mapbox/streets-v11';

function getSrc(
  width: number,
  height: number,
  markers: string,
  accessToken: string
): string {
  return `https://api.mapbox.com/styles/v1/${mapStyle}/static/${markers}/auto/${width}x${height}?access_token=${accessToken}`;
}

const StaticStationMap = ({
  mapboxApiAccessToken,
  dockGroups,
  primaryColor
}: Props) => {
  const pinColor = primaryColor.substr(1);

  const markers = dockGroups
    .reduce<string[]>((accum, dockGroup) => {
      if (
        dockGroup &&
        dockGroup.coord &&
        dockGroup.coord.lat &&
        dockGroup.coord.lng
      ) {
        accum.push(
          `pin-s-bicycle+${pinColor}(${dockGroup.coord.lng},${dockGroup.coord.lat})`
        );
      }
      return accum;
    }, [])
    .join(',');

  const largeSrc = getSrc(1200, 675, markers, mapboxApiAccessToken);
  return (
    <Box position="relative">
      <MapOverlay>
        <Stats />
      </MapOverlay>
      <Image src={largeSrc} alt="station map" />
    </Box>
  );
};

export default StaticStationMap;
